import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-organisation-settings-view',
  templateUrl: './organisation-settings-view.component.html',
  styleUrls: ['./organisation-settings-view.component.scss'],
})
export class OrganisationSettingsViewComponent {}
